import React from 'react'

const Manual_descargar_clientes_masivamente = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          ¿Cómo descargar clientes masivamente?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Descubre cómo exportar clientes en masa desde el Dashboard de Clau.io para respaldos o análisis.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_descargar_clientes_masivamente__OspzO9y4T2iCqI0lSZH5QA?as=scrollable"
          className="scribe-iframe-general-95"
          width="100%"
          height="3100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_descargar_clientes_masivamente
